import {
    IAiImgRequest,
    IAiImgResponse,
    FetchDataRequestAction,
    FetchDataSuccessAction,
    FetchDataErrorAction,
    SelectIngredientAction,
    ResetAction,
} from './types';

export const FETCH_DATA_REQUEST = 'FETCH_AI_CHEF_DATA_REQUEST';
export const FETCH_DATA_SUCCESS = 'FETCH_AI_CHEF_DATA_SUCCESS';
export const FETCH_DATA_ERROR = 'FETCH_AI_CHEF_DATA_ERROR';
export const SET_DATA_AI_CHEF = 'SET_DATA_AI_CHEF';
export const SELECT_INGREDIENT = 'AI_CHEF_SELECT_INGREDIENT';
export const UPDATE_REQUEST_TYPE = 'AI_CHEF_UPDATE_REQUEST_TYPE';
export const RESET = 'AI_CHEF_RESET';

export const FetchDataRequest = (data: IAiImgRequest): FetchDataRequestAction => ({
    type: FETCH_DATA_REQUEST,
    payload: data,
});

export const fetchDataSuccess = (data: IAiImgResponse): FetchDataSuccessAction => ({
    type: FETCH_DATA_SUCCESS,
    payload: data,
});

export const fetchDataError = (error: Error): FetchDataErrorAction => ({
    type: FETCH_DATA_ERROR,
    payload: error,
});

export const setDataAiChef = (data: {
    data: IAiImgResponse;
    params: IAiImgRequest;
}): any => ({
    type: SET_DATA_AI_CHEF,
    payload: data,
});

export const selectIngredients = (data: any[]): SelectIngredientAction => ({
    type: SELECT_INGREDIENT,
    payload: data,
});

export const updateRequestType = (data: any): any => ({
    type: UPDATE_REQUEST_TYPE,
    payload: data,
});

export const resetAiChef = (resetParam: boolean): ResetAction => ({
    type: RESET,
    payload: resetParam,
});
